import { Transition, TransitionService } from '@uirouter/core';

import { SessionService } from '../sessions/session.service';

export function UsersResolver (
  $transitions : TransitionService,
  sessionObjAPI: SessionService
) {
  $transitions.onStart({
    to: 'app.users'
  }, ( transition : Transition ) => {
    if ( !sessionObjAPI.isAdminUser() ) {
      return false;
    }
  });
}
